import api from "../api";
import axios from "../utils/axios.instance";
import handleError from "./handle-error";
import { ICreateInterviewResponse, IGetInterviewByIdResponse, IListInterviewPayload, IListInterviewResponse } from "./types/interview.type";

export const createInterview = async (payload) => {
  try {
    const { data }: {
      data: ICreateInterviewResponse
    } = await axios.post(api.createInterview, payload);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

export const updateInterview = async (interviewId, payload) => {
  try {
    const { data } = await axios.patch(
      api.updateInterview + `/${interviewId}`,
      payload
    );
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

export const confirmSlotAvailability = async (interviewId, payload) => {
  try {
    const { data } = await axios.patch(
      api.confirmSlotAvailability + `/${interviewId}`,
      payload
    );
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

export const deleteInterview = async (interviewId) => {
  try {
    const { data } = await axios.delete(
      api.deleteInterview + `/${interviewId}`
    );
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

interface IMarkReadInterviewPayload {
  interviewId: string
  role: 'recruiter' | 'candidate' | 'hiringCompany'
}

export const markReadInterview = async ({ interviewId, role }: IMarkReadInterviewPayload) => {
  try {
    const { data } = await axios.patch(api.readInterview(interviewId), {
      role
    });
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

export const candidateAutoComplete = async (searchText) => {
  try {
    const params = new URLSearchParams({ search: searchText });

    const { data } = await axios.get(
      `${api.candidateAutoComplete}?${params.toString()}`
    );

    return data;
  } catch (err) {
    throw handleError(err);
  }
};

export const listInterview = async ({
  isSchedule, fetchGeneralSlotInterviews
}: IListInterviewPayload = {
    isSchedule: false,
    fetchGeneralSlotInterviews: false
  }) => {
  try {
    const params = new URLSearchParams();
    if (isSchedule) params.append('isSchedule', isSchedule.toString())
    if (fetchGeneralSlotInterviews) params.append('fetchGeneralSlotInterviews', fetchGeneralSlotInterviews.toString())
    const generalURL = api.listInterviews
    const URL = params.toString() ? generalURL + `?${params?.toString()}` : generalURL
    const { data }: {
      data: {
        success: boolean,
        data: IGetInterviewByIdResponse[] | undefined
      }
    } = await axios.get(URL);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

export const listRecruiterInterview = async () => {
  try {
    const { data } = await axios.get(api.listRecruiterInterview);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};


//Invite confirmation
export const acceptOrDeclineInviteConfirmation = async (payload: {
  id: string, //interviewId
  isConfirmInterview: boolean
}) => {
  try {
    const { data } = await axios.patch(api.confirmInterview, payload);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

export const getInterviewDetails = async (interviewId) => {
  try {
    const { data }: {
      data: {
        data: IGetInterviewByIdResponse,
        success: boolean
      }
    } = await axios.get(
      api.getInterviewDetails + `/${interviewId}/details`
    );
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

export const acceptOrDeclineInterview = async (payload) => {
  try {
    const { data } = await axios.patch(api.acceptInterview, payload);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

export const listCandidateInterview = async (candidateId) => {
  try {
    const params = new URLSearchParams({ candidateId });
    const { data } = await axios.get(
      `${api.listCandidateInterview}?${params?.toString()}`
    );
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

export const jobAutoComplete = async ({ searchText, candidateId }) => {
  try {
    const { data } = await axios.get(
      api.jobAutoComplete + `?search=${searchText}&candidateId=${candidateId}`
    );
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

export const forwardInterview = async (interviewId: string) => {
  try {
    const { data }: {
      data: {
        success: boolean,
        data: IGetInterviewByIdResponse
      }
    } = await axios.patch(api.forwardInterview + `/${interviewId}`);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

export const sendInterviewInvite = async (payload: { id: string, slotId: string }) => { //interviewId
  try {
    const { data }: {
      data: {
        success: boolean,
        data: IGetInterviewByIdResponse
      }
    } = await axios.post(api.sendInterviewInvite, payload);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

//Availabilities
export const listAvailabilities = async (candidateId) => {
  try {
    const { data } = await axios.get(
      api.listAvailabilities + `?candidateId=${candidateId}`
    );
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

export const addAvailability = async (payload) => {
  try {
    const { data } = await axios.post(api.addAvailability, payload);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

export const deleteAvailability = async (slotId) => {
  try {
    const { data } = await axios.delete(api.deleteAvailability + `/${slotId}`);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};
